"use client";

import { Badge } from "@/components/ui/badge";
import { CheckCircle } from "lucide-react";
import { motion } from "motion/react";
import Image from "next/image";

export default function AboutComponent() {
  return (
    <section className="wrapper relative square-gradient-bg py-10">
      <motion.div
        initial={{ opacity: 0, y: 150 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
        className={"flex flex-col gap-5"}
      >
        <Badge className="">About VisionTech Trading</Badge>
        <div className={"grid md:grid-cols-2 gap-5 font-semibold"}>
          <div className={"flex flex-col gap-5"}>
            <h1 className={"text-4xl font-bold"}>
              Leading the Future of <br />{" "}
              <span className={"text-primary"}>
                Technology Trading VisionTech
              </span>
            </h1>
            <p>
              VisionTech Trading stands as one of Bhutan&apos;s premier trading
              houses, with our registered headquarters in Thimphu. We operate
              across multiple locations in Bhutan while maintaining a strong
              international presence.
            </p>
            <p>
              Founded with the vision to revolutionize Bhutan&apos;s trading
              landscape, we specialize in introducing cutting-edge technologies
              and international-standard products to the Bhutanese market.
            </p>
            <div className="grid grid-cols-2 gap-6">
              <div className="space-y-2">
                <CheckCircle className="h-6 w-6 text-primary" />
                <h3 className="font-semibold text-primary">Global Network</h3>
                <p className="text-muted-foreground text-sm">
                  International partnerships across Asia
                </p>
              </div>
              <div className="space-y-2">
                <CheckCircle className="h-6 w-6 text-primary" />
                <h3 className="font-semibold text-primary">Quality Assured</h3>
                <p className="text-muted-foreground text-sm">
                  Premium products meeting international standards
                </p>
              </div>
            </div>
          </div>
          <Image
            src={
              "https://st3.depositphotos.com/8911320/33966/i/450/depositphotos_339665118-stock-photo-render-modern-office-interior.jpg"
            }
            alt={"Office"}
            width={500}
            height={500}
            className={"w-full h-full object-cover rounded"}
          />
        </div>
      </motion.div>
    </section>
  );
}
